import AttachmentList from './attachmentList'

export default AttachmentList
